import React from 'react'
import Pill from 'components/Luxkit/Pill'
import { getHotelOfferDisplayedValue } from 'lib/offer/getOfferDisplayPricing'
import { isTourV2OfferType } from 'lib/offer/offerTypes'
import Group from 'components/utils/Group'
import PriceRowPrice from 'components/Luxkit/PricePoints/PriceRowPrice'
import PriceRowPriceCaption from 'components/Luxkit/PricePoints/PriceRowPriceCaption'

interface Props {
  offerType: App.OfferType
  duration?: string
  price: number
  value?: number
  shouldDisplayValue?: boolean
}

function HotelPriceContent({
  offerType,
  duration,
  price,
  value,
  shouldDisplayValue = false,
}: Props) {
  let hotelOfferDisplayValue: ReturnType<typeof getHotelOfferDisplayedValue> | undefined
  const isTourV2 = isTourV2OfferType(offerType)
  if (!isTourV2) {
    hotelOfferDisplayValue = getHotelOfferDisplayedValue(false, price, value ?? price, shouldDisplayValue)
  }

  const durationText = duration ? `${duration} from` : 'From'

  return (
    <Group direction="vertical">
      <PriceRowPriceCaption>{durationText}</PriceRowPriceCaption>
      <Group direction="horizontal" gap={4}>
        <PriceRowPrice
          size="S"
          price={Math.ceil(price)}
          saleUnit="total"
          /** @todo Probably YmalPricingProperties needs to include refs to taxes and fees! */
          taxesAndFees="inclusive"
        />

        {!isTourV2 && hotelOfferDisplayValue?.shouldShowDiscountPercent &&
          <Pill kind="primary" variant="success">
            Save up to {hotelOfferDisplayValue.highestDiscountPercent}%
          </Pill>
        }
      </Group>
    </Group>
  )
}

export default HotelPriceContent
